(function () {
  var drawer = document.getElementById('OverlandDrawer');
  if (!drawer) return;
  var openers = document.querySelectorAll('[data-of-drawer-open]');
  var closers = drawer.querySelectorAll('[data-of-drawer-close]');
  var lastFocus = null;

  function focusables() {
    return drawer.querySelectorAll('a[href], button:not([disabled])');
  }

  function open() {
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var f = focusables();
    if (f.length) f[0].focus();
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  openers.forEach(function (b) { b.addEventListener('click', open); });
  closers.forEach(function (c) { c.addEventListener('click', close); });

  document.addEventListener('keydown', function (e) {
    if (!drawer.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
})();
